import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withCookies } from "react-cookie";
import { connect } from "react-redux";
import styled from "styled-components";
import scale from "../helper/scaling";
import text from "../helper/text";

import Logo from "./Logo";
import { store } from "../redux/store";
import { setLocale } from "../redux/actions/controllers/locale";

const Wrapper = styled.div`
  width: calc(100% - 50px);
  height: 62px;
  padding: 0 25px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  position: fixed;
  top: 0;
  left: 0;
  border-bottom: solid 1px #e5e5e5;

  background-color: ${props =>
    props.safari ? "rgba(255, 255, 255, 0.8)" : "#ffffff"};
  ${props => (props.safari ? "backdrop-filter: blur(10px)" : "")};

  @media (max-width: 1120px) {
    justify-content: center;
  }
`;
const MenuButton = styled.div`
  display: none;
  @media (max-width: 1120px) {
    display: flex;
    order: 1;
    position: absolute;
    left: 22px;
    height: 100%;
    top: 0;
    align-items: center;
    cursor: pointer;
  }
  @media (max-width: 700px) {
    left: 20px;
  }
`;
const MenuUserButton = styled.div`
  display: none;

  @media (max-width: 700px) {
    position: absolute;
    margin-right: 25px;
    right: 25px;
    height: 100%;
    top: 0;
    cursor: pointer;

    display: flex;
    align-items: center;
    z-index: 300;
  }
`;
const MenuIconWrapper = styled.div`
  width: 26px;
  height: 26px;

  svg {
    width: 100%;
    height: 100%;
    fill: #3949ab;
  }
`;
const MenuUserIconWrapper = styled.div`
  width: 26px;
  height: 26px;

  svg {
    width: 100%;
    height: 100%;
    fill: #3949ab;
  }
`;
const LogoWrapper = styled.div`
  padding-top: 3px;
  cursor: pointer;
  @media (max-width: 1120px) {
    order: 2;
  }
  @media (max-width: 700px) {
    padding-top: 8px;
  }
`;
const MenuWrapper = styled.div`
  display: flex;
  margin-left: 15px;
  white-space: nowrap;
  align-items: center;
  @media (max-width: 1120px) {
    display: ${props => (props.open ? "flex" : "none")};
    flex-direction: column;
    position: fixed;
    top: 63px;
    left: 0;
    width: 369px;
    opacity: 0.98;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);

    padding: 0 0 60px 0;
  }
  @media (max-width: 700px) {
    width: 100%;
    min-height: calc(100vh - 63px);
    box-shadow: none;
  }
`;
const MenuWrapperSmall = styled.div`
  display: none;
  @media (max-width: 700px) {
    display: ${props => (props.open ? "flex" : "none")};
    flex-direction: column;
    position: fixed;
    top: 63px;
    left: 0;
    right: 0;
    opacity: 0.98;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    padding: 0 0 140px 0;
  }
`;
const UserActionsWrapper = styled.div`
  margin: 0 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;

  @media (max-width: 1370px) {
    position: absolute;
    height: 100%;
    top: 0;
    right: 25px;

    flex-direction: column-reverse;
    justify-content: center;
    align-items: flex-end;
  }
  @media (max-width: 700px) {
    display: none;
  }
`;
const UserActionsRow = styled.div`
  margin: 0 25px 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 1370px) {
    margin-right: 0;
  }
  @media (max-width: 700px) {
    display: none;
  }
`;
const UserActionsWrapperSmall = styled.div`
  display: none;
  @media (max-width: 700px) {
    position: absolute;
    display: block;
    width: 100%;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 1rem 25px;
  }
`;
const UserAction = styled.a`
  float: left;
  margin: 0 7px;
  padding: 4px 0;

  display: block;

  text-transform: uppercase;

  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  line-height: 12px;
  letter-spacing: 0.7px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  text-decoration: none;

  :first-of-type {
    margin-left: 0;
  }
  :last-of-type {
    margin-right: 0;
  }

  :hover {
    opacity: 0.9;
  }
  :active {
    opacity: 0.7;
  }
`;
const UserActionSmall = styled.a`
  margin: 4px 0;
  padding: 4px 0;
  display: block;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  letter-spacing: 1px;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  text-decoration: none;

  :hover {
    opacity: 0.9;
  }
  :active {
    opacity: 0.7;
  }
`;
const RedUserAction = UserAction.extend`
  padding-bottom: 3px;
  border-bottom: solid 1px #ff5368;
  color: #ff5368;
`;
const RedUserActionSmall = UserAction.extend`
  margin: 4px 0;
  padding: 4px 0;
  display: block;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  letter-spacing: 1px;
  border-bottom: solid 1px #ff5368;
  color: #ff5368;
`;
const Search = styled.div`
  padding: 5px 32px 5px 10px;
  border-radius: 17px;
  background-color: #f9f9f9;
  border: solid 1px #dcdcdc;
  float: left;
  margin-left: 16px;
  position: relative;
  @media (max-width: 1120px) {
    order: 1;
    width: calc(100% - 92px);
    margin: 19px 25px 20px 25px;
  }
`;
const SearchInput = styled.input`
  width: 152px;
  height: 17px;

  margin: 0;
  padding: 0;
  border: 0;

  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  background: none;

  background-color: #f9f9f9;

  font-family: Lato;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.2px;
  color: rgba(0, 0, 0, 0.85);

  float: left;

  :focus {
    outline: 0;
  }
  @media (max-width: 1120px) {
    width: 100%;
  }
`;
const SearchButton = styled.div`
  cursor: pointer;
  width: 19px;
  height: 19px;
  position: absolute;
  top: 4px;
  right: 11px;
  svg {
    height: 100%;
    width: 100%;
  }
`;

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, openUser: false };
    this.searchForm = React.createRef();

    this.login_name = this.props.cookies.get("auction_login");

    this.closeMenuOnNavigation = this.closeMenuOnNavigation.bind(this);
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open, openUser: false });
  };

  toggleMenuUser = () => {
    this.setState({ openUser: !this.state.openUser, open: false });
  };

  closeMenuOnNavigation (event) {
    if (event.target && event.target.tagName.toLowerCase() === 'a') {
      this.setState({ open: false, openUser: false });
    }
  };

  clickSearchButton = () => {
    this.searchForm.current.submit();
  };

  switchPageChild = content => {
    if (this.state.open) {
      this.setState({ open: false });
    }
  };

  render() {
    var translations = this.props.translations;

    var menu = [];
    if (this.props.contentMenu && this.props.contentMenu.menu) {
      menu = this.props.contentMenu.menu.filter(
        i => i.short && !i.short.startsWith("home")
      );
    }

    let auctionBaseUrl = "/portal";
    if (
      this.props.auction &&
      this.props.auctions &&
      this.props.auctions[this.props.auction] &&
      this.props.auctions[this.props.auction].url
    ) {
      auctionBaseUrl = this.props.auctions[this.props.auction].url;
    }

    var safari =
      navigator.userAgent.toLowerCase().indexOf("safari") !== -1 &&
      !(navigator.userAgent.toLowerCase().indexOf("chrome") > -1);
    return (
      <Wrapper safari={safari}>
        <MenuButton onClick={this.toggleMenu}>
          <MenuIconWrapper>
            <MenuIcon />
          </MenuIconWrapper>
        </MenuButton>
        <LogoWrapper>
          <Link to='/home'><Logo /></Link>
        </LogoWrapper>
        <MenuWrapper open={this.state.open} onClick={this.closeMenuOnNavigation}>
          {menu && menu.length > 0
            ? menu.map(item => (
                <MenuItem
                  key={item.short}
                  content={item}
                  switchPage={this.switchPageChild}
                />
              ))
            : [1, 2, 3, 4, 5].map((a, i) => (
                <MenuItemWrapper key={i}>
                  {text.get({}, "tmp", 7)}
                </MenuItemWrapper>
              ))}
          <Search>
            <form
              ref={this.searchForm}
              method="GET"
              action={auctionBaseUrl + "/auction"}
            >
              <SearchInput name="keyword" />
              <SearchButton onClick={this.clickSearchButton.bind(this)}>
                <SearchIcon />
              </SearchButton>
            </form>
          </Search>
        </MenuWrapper>
        {this.login_name ? (
          <UserActionsWrapper>
            <UserActionsRow>
              <UserAction href={auctionBaseUrl + "/my_catalogue"}>
                {text.get(translations, "My_catalogue", 10)}
              </UserAction>
              <UserAction href={auctionBaseUrl + "/logout"}>
                {text.get(translations, "Log_out", 12)}
              </UserAction>
            </UserActionsRow>
            <UserAction href={auctionBaseUrl + "/my/account"}>
              {text.get(translations, "Welcome")}
              {" "}
              {this.login_name.replace(/\+/g, " ")}
            </UserAction>
          </UserActionsWrapper>
        ) : (
          <UserActionsWrapper>
            <UserAction href={auctionBaseUrl + "/login"}>
              {text.get(translations, "Login", 10)}
            </UserAction>
            <RedUserAction href={auctionBaseUrl + "/registration"}>
              {text.get(translations, "Register", 12)}
            </RedUserAction>
          </UserActionsWrapper>
        )}
        <LocaleSwitcher
          locale={this.props.locale}
          locales={this.props.locales}
        />
        <MenuUserButton onClick={this.toggleMenuUser}>
          <MenuUserIconWrapper>
            <MenuUserIcon />
          </MenuUserIconWrapper>
        </MenuUserButton>
        <MenuWrapperSmall open={this.state.openUser} onClick={this.closeMenuOnNavigation}>
          {this.login_name ? (
            <UserActionsWrapperSmall>
              <UserActionSmall href={auctionBaseUrl + "/my/account"}>
                {text.get(translations, "Welcome")}
                {" "}
                {this.login_name.replace(/\+/g, " ")}
              </UserActionSmall>
              <UserActionSmall href={auctionBaseUrl + "/my_catalogue"}>
                {text.get(translations, "My_catalogue", 10)}
              </UserActionSmall>
              <UserActionSmall href={auctionBaseUrl + "/logout"}>
                {text.get(translations, "Log_out", 12)}
              </UserActionSmall>
            </UserActionsWrapperSmall>
          ) : (
            <UserActionsWrapperSmall>
              <UserActionSmall href={auctionBaseUrl + "/login"}>
                {text.get(translations, "Login", 10)}
              </UserActionSmall>
              <RedUserActionSmall href={auctionBaseUrl + "/registration"}>
                {text.get(translations, "Register", 12)}
              </RedUserActionSmall>
            </UserActionsWrapperSmall>
          )}
        </MenuWrapperSmall>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    auction: state.auction.data,
    auctions: state.auctions.data,
    contentMenu: state.contentMenu.data,
    locale: state.locale.data,
    locales: state.locales.data || [],
    translations: state.translations.data
  };
};

export default withCookies(connect(mapStateToProps, null)(Menu));

const MenuItemChildrenBackdrop = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 100;
  left: 0;
  display: ${props => (props.open ? "flex" : "block")};
  @media (max-width: 1120px) {
    display: none;
  }
`;

const MenuItemWrapper = styled.div`
  margin: 0 14px 1px 14px;
  float: left;
  text-transform: uppercase;

  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  letter-spacing: 1px;

  @media (max-width: 1350px) {
    margin: 0 ${scale(1350, 1100, 14, 4, "vw")} 1px
      ${scale(1350, 1100, 14, 4, "vw")};
  }
  @media (max-width: 1120px) {
    order: 2;
    width: calc(100% - 108px);
    margin: 5px 60px 5px 48px;
  }
`;

const MenuItemClickable = styled.div`
  cursor: pointer;
  color: ${props => (props.open ? "#3949ab" : "rgba(0, 0, 0, 0.85)")};
`;

const MenuItemLink = styled.a`
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
`;

const MenuItemChildren = styled.div`
  position: fixed;
  top: 63px;
  left: calc(
    50vw
      ${props =>
        props.left
          ? props.left - 21 < 0
            ? `- ${Math.abs(props.left - 21)}`
            : `+ ${props.left - 21}`
          : "0"}px
  );
  background-color: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  padding: 14px 0;

  display: ${props => (props.open ? "flex" : "none")};
  flex-direction: column;

  @media (max-width: 1120px) {
    position: relative;
    display: ${props => (props.open ? "block" : "none")};
    top: 0;
    left: 0;

    max-height: ${props => (props.open ? "auto" : "0px")};
    overflow: hidden;

    box-shadow: none;
    padding: 5px 0;
  }
`;

class MenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      left: 0
    };
  }

  getWidth = () => {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  };

  getLeft = () => {
    return this.clickable.getBoundingClientRect().left;
  };

  toggleItem = () => {
    this.setState({
      open: !this.state.open,
      left: this.state.open ? 0 : this.getLeft() - this.getWidth() / 2
    });
  };

  clickHandler = () => {
    if (
      this.props.content &&
      this.props.content.children &&
      this.props.content.children.length > 0
    ) {
      this.toggleItem();
    }
  };

  switchPageChild = content => {
    this.setState({ open: false });
  };

  toggleOpenOnHover = () => {
    let innerWidth = window.innerWidth
    if (innerWidth > 1120) this.setState({ open: !this.state.open })
  }

  closeOnHover = () => {
    let innerWidth = window.innerWidth
    if (innerWidth > 1120) this.setState({ open: false })
  }

  render() {
    const { content } = this.props

    if (!content) return null
    if (content.type && content.type === 'url' && !!content.link) {
      return (
        <MenuItemWrapper>
          <MenuItemClickable
            innerRef={el => (this.clickable = el)}
            open={this.state.open}
            onClick={this.clickHandler}
          >
            <MenuItemLink href={content.link}>
              {content.title || ""}
            </MenuItemLink>
          </MenuItemClickable>
        </MenuItemWrapper>
      )
    }
    return (
      <MenuItemWrapper onMouseEnter={this.toggleOpenOnHover} onMouseLeave={this.closeOnHover}>
        <MenuItemClickable
          innerRef={el => (this.clickable = el)}
          onClick={this.clickHandler}
          open={this.state.open}
        >
          {content.title || ""}
        </MenuItemClickable>
        { this.state.open &&
          <MenuItemChildrenBackdrop
            open={this.state.open}
            onClick={this.clickHandler}
          />
        }
        {content.children && content.children.length > 0 ? (
          <MenuItemChildren open={this.state.open} left={this.state.left}>
            {content.children.map(item => (
              <MenuChild
                key={item.short}
                content={item}
                switchPage={this.switchPageChild}
              />
            ))}
          </MenuItemChildren>
        ) : (
          []
        )}
      </MenuItemWrapper>
    );
  }
}

const MenuChildWrapper = styled.div`
  text-transform: uppercase;
  padding: 2px 0;
  height: auto;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 15px;
  letter-spacing: 0.8px;
  color: rgba(0, 0, 0, 0.85);

  cursor: pointer;

  :hover {
    background-color: #f4f4f4;
  }

  @media (max-width: 1120px) {
    height: auto;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.8px;
    color: rgba(0, 0, 0, 0.85);

    :hover {
      background-color: rgba(255, 255, 255, 0);
    }
  }
`;
const MenuSeparator = styled.div`
  height: 0;
  border-bottom: 1px solid #e5e5e5;
  margin: 7px 0;
`;

class MenuChild extends Component {
  clickHandler = () => {
    this.props.switchPage(this.props.content);
  };

  render() {
    const { content } = this.props
    if (
      content &&
      content.type &&
      content.type.toLowerCase() === "separator"
    ) {
      return <MenuSeparator />;
    }
    return (
      <MenuChildWrapper onClick={this.clickHandler}>
        <CustomLink
          link={content && content.link && content.link.startsWith('http')
           ? content.link
           : content.short
          }
          text={content && content.title
            ? content.title
            : ""} />
      </MenuChildWrapper>
    );
  }
}

const MenuChildLink = styled.a`
  text-transform: uppercase;
  text-decoration: none;
  padding: 7px 30px 7px 21px;
  color: rgba(0, 0, 0, 0.85);
  display: block;

  :link {
    color: rgba(0, 0, 0, 0.85);
  }

  :visited {
    color: rgba(0, 0, 0, 0.85);
  }

  :active {
    color: rgba(0, 0, 0, 0.85);
  }

  :hover {
    color: rgba(0, 0, 0, 0.85);
    background-color: #f4f4f4;
  }

  @media (max-width: 1120px) {
    padding: 4px 0px;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.8px;
    color: rgba(0, 0, 0, 0.85);

    :hover {
      background-color: rgba(255, 255, 255, 0);
    }
  }
`;
const CustomLinkWrapper = styled.div`
  a {
    display: block;
    padding: 7px 30px 7px 21px;
    text-decoration: none;

    @media (max-width: 1120px) {
      padding: 4px 0px;
      text-decoration: none;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  a:visited {
    color: rgba(0, 0, 0, 0.85);
  }
  a:link {
    color: rgba(0, 0, 0, 0.85);
  }
  a:active {
    color: rgba(0, 0, 0, 0.85);
  }
  a:hover {
    color: rgba(0, 0, 0, 0.85);
  }
`;

class CustomLink extends Component {
  render () {
    const { link, text } = this.props

    if (link.startsWith("http")) return <MenuChildLink href={link}>{ text }</MenuChildLink>
    return (
      <CustomLinkWrapper><Link to={link}>{text}</Link></CustomLinkWrapper>
    );
  }
};

class SearchIcon extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
  }
}

class MenuIcon extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      </svg>
    );
  }
}

class MenuUserIcon extends Component {
  render() {
    return (
      <div style={{ width: 24, height: 24, borderRadius: 24, border: 'solid 3px #3949ab' }} />
      // <svg
      //   xmlns="http://www.w3.org/2000/svg"
      //   width="24"
      //   height="24"
      //   viewBox="0 0 24 24"
      // >
      //   <path d="M0 0h24v24H0z" fill="none" />
      //   <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
      // </svg>
    );
  }
}

const LocaleSwitcherWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: ${props => (props.open ? "100%" : "0")};
  height: ${props => (props.open ? "100%" : "0")};
  z-index: 500;
`;

const LocaleSwitcherBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const Flags = styled.div`
  position: fixed;
  top: 15px;
  right: ${props => (props.open ? "15px" : "0")};
  width: ${props => (props.open ? "44px" : "25px")};
  transition: ${props =>
    props.open
      ? "width 200ms ease, right 200ms ease"
      : "width 200ms ease 150ms, right 200ms ease 150ms"};
  cursor: pointer;
`;

const Flag = styled.div`
  height: 33px;
  width: 44px;
  position: absolute;
  transition: ${props =>
    props.open
      ? "top 200ms ease 150ms, opacity 200ms ease 150ms"
      : "top 200ms ease, opacity 200ms ease"};
  top: ${props => (props.open ? `${44 * props.index}px` : "0")};
  left: 0;
  opacity: ${props => (props.open || props.current ? "1" : "0")};
  background-color: #ffffff;
`;

class LocaleSwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    return (
      <LocaleSwitcherWrapper open={this.state.open}>
        <LocaleSwitcherBackdrop onClick={this.close} />
        <Flags open={this.state.open}>
          { this.props.locales.map((l, i) => {
            const wrap = svg => (
              <Flag
                current={this.props.locale === l}
                key={l}
                onClick={this.clickHandler(l)}
                index={i}
                open={this.state.open}
              >
                {svg}
              </Flag>
            );
            switch (l) {
              case "nl_NL":
                return wrap(<NlFlag />);
              case "en_GB":
                return wrap(<UkFlag />);
              case "zh_CN":
                return wrap(<CnFlag />);
              default:
                console.warn(`Missing flag for locale "${l}"`);
                return null
            }
          })}
        </Flags>
      </LocaleSwitcherWrapper>
    );
  }

  clickHandler = locale => () => {
    if (this.state.open) {
      this.close();
      console.log(locale);
      store.dispatch(setLocale(locale));
    } else {
      this.open();
    }
  };

  close = () => {
    this.setState({ open: false });
  };

  open = () => {
    this.setState({ open: true });
  };
}

/* Flags from flag-icon-css */
class CnFlag extends Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
        <path fill="#de2910" d="M0 0h640v480H0z" />
        <g fill="#ffde00">
          <g width="30" height="20" transform="matrix(71.9991 0 0 72 120 120)">
            <path d="M-.6.8L0-1 .6.8-1-.3h2z" />
          </g>
          <g
            width="30"
            height="20"
            transform="matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
          >
            <path d="M-.6.8L0-1 .6.8-1-.3h2z" />
          </g>
          <g
            width="30"
            height="20"
            transform="matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
          >
            <path d="M-.6.8L0-1 .6.8-1-.3h2z" />
          </g>
          <g
            width="30"
            height="20"
            transform="matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
          >
            <path d="M-.6.8L0-1 .6.8-1-.3h2z" />
          </g>
          <g
            width="30"
            height="20"
            transform="matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
          >
            <path d="M-.6.8L0-1 .6.8-1-.3h2z" />
          </g>
        </g>
      </svg>
    );
  }
}

class NlFlag extends Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
        <g fillRule="evenodd" strokeWidth="1pt" transform="scale(1.25 .9375)">
          <rect width="512" height="509.8" fill="#fff" rx="0" ry="0" />
          <rect
            width="512"
            height="169.9"
            y="342.1"
            fill="#21468b"
            rx="0"
            ry="0"
          />
          <path fill="#ae1c28" d="M0 0h512v170H0z" />
        </g>
      </svg>
    );
  }
}

class UkFlag extends Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
        <path fill="#012169" d="M-161 0h963v481h-963z"/>
        <path fill="#fff" d="M-161 0v54l855 427h108v-53L-53 0h-108zm963 0v54L-53 481h-108v-53L694 0h108z"/>
        <path fill="#fff" d="M240 0v481h161V0H240zm-401 160v161h963V160h-963z"/>
        <path fill="#c8102e" d="M-161 193v96h963v-96h-963zM273 0v481h96V0h-96zm-434 481l321-160h72L-89 481h-72zm0-481l321 160H88L-161 36V0zm570 160L730 0h72L481 160h-72zm393 321L481 321h72l249 124v36z"/>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js